import actionTypes from '../actions/types';

export const INITIAL_STATE = {
  allAccountAsset: [],
  transferHistory: {},
  transferSuccessInfo: {},
};
export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ASSET_TRANSFER_HISTORY_BY_ID_SUCCESS:
      return { ...state, transferSuccessInfo: action.data };
    case actionTypes.FETCH_SUB_ACCOUNT_ASSET_BY_COIN_SUCCESS:
      return { ...state, allAccountAsset: action.data };
    case actionTypes.FETCH_ASSET_TRANSFER_HISTORY_SUCCESS:
      return { ...state, transferHistory: action.data };
    default:
      return state;
  }
};
